import { Prospectregister } from '../models/prospectregister';

export class Register {
    constructor (
        public FirstName: string = '',
        public LastName: string = '',
        public Email: string = '',
        public Password: string = '',
        public PhoneNumber: string = '',
        public AgreedToTerms: string = ''
    ) { }

    LoadFromProspectRegister(pReg: Prospectregister)
    {
        this.FirstName = pReg.FirstName;
        this.LastName = pReg.LastName;
        this.Email = pReg.Email;
        this.Password = pReg.ConfirmPassword;
        this.PhoneNumber = pReg.CellPhone
    }
}
